import React from 'react';

export const Squares = () => {
  return (
    <div className="flex flex-col">
      <div className="flex">
        <div className="h-3 w-3 bg-[#301E0E]"></div>
        <div className="h-3 w-3 bg-[#786238]"></div>
        <div className="h-3 w-3 bg-[#7C8676]"></div>
      </div>
      <div className="flex">
        <div className="h-3 w-3 bg-[#989DA1]"></div>
        <div className="h-3 w-3 bg-[#AA9053]"></div>
        <div className="h-3 w-3 bg-[#393937]"></div>
      </div>
    </div>
  );
};
